/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * 多言語対応について
 *
 * 【多言語】の下部に記載されているコメントアウトを外すと利用可能となる
 * ただし、辞書ファイルは最新状態になっていないと思うので、チェックが必要
 */

import 'es6-promise/auto';
import 'babel-polyfill';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../sass/custom-theme/auth/_import.scss';
import locale from 'element-ui/lib/locale';
// 【多言語】
// import enLocale from 'element-ui/lib/locale/lang/en';
import jaLocale from 'element-ui/lib/locale/lang/ja';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import router from './auth/router';
import BodyClass from 'vue-body-class';
import store from './store/index';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas, far, fab);
dom.watch();

Vue.use(ElementUI, { size: 'small' });
Vue.use(VueI18n);
Vue.use(BodyClass, router);

// 【多言語】
// let language = navigator.language.split('-')[0];
let language = 'ja';
// 【多言語】
// if (language === 'ja') {
//     locale.use(jaLocale);
// } else if (language === 'en') {
//     locale.use(enLocale);
// } else {
    locale.use(jaLocale);
// }

// 【多言語】
// let en_data = Object.assign(
//     /* 各機能ページの辞書ファイル */
//     require('../lang/en/page.json'),
//     /* 共通項目の辞書ファイル */
//     require('../lang/en/attributes.json')
// );

let ja_data = Object.assign(
    /* 各機能ページの辞書ファイル */
    require('../lang/ja/page.json'),
    /* 共通項目の辞書ファイル */
    require('../lang/ja/attributes.json')
);

const i18n = new VueI18n({
    locale: language,
    messages: {
        // 【多言語】
        // en: en_data,
        ja: ja_data
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    store,
    router,
    i18n,
    el: '#body-content'
});
